import type { AppState } from "store/types";

export const getWorkflowSidebarKey = (_state: AppState) => undefined;
